import { useGetPendingMessagesQuery } from "api/apiSlice";
import { StreamList } from "../streams/streamList";
import { PendingMessage } from "./pendingMessage";
import { NukeView } from "../streams/nuke";

export const PendingMessagesList = () => {
  const {
    data: pendingMessages = [],
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetPendingMessagesQuery(null, {
    pollingInterval: 10000,
  });

  let content;

  if (isSuccess || isLoading) {
    if (pendingMessages.length > 0) {
      content = pendingMessages.map((m) => (
        <PendingMessage key={m.messageId} message={m} />
      ));
    } else {
      content = (
        <tr>
          <td>
            <h3 className="text-center">There are no pending messages</h3>
          </td>
        </tr>
      );
    }
  } else if (isError) {
    if ("data" in error)
      content = (
        <tr>
          <td>Oh no! A wild {error.status} error appeared!</td>
        </tr>
      );
  }

  return (
    <div className="container text-light pt-2">
      <div className="row">
        <h2 className="text-light">New Messages ({pendingMessages.length})</h2>
      </div>
      <div className="row pt-1">
        <table className="table table-dark table-striped table-hover table-bordered">
          <tbody>{content}</tbody>
        </table>
      </div>
      <StreamList />
      <NukeView />
    </div>
  );
};
